import React, { useMemo } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';

const JobWorkDetailsModal = ({
    detailsModalOpen,
    setDetailsModalOpen,
    data,
}) => {
    const cols = [
        {
            Header: 'Card Number',
            accessor : 'cuttingCardNumber'
        },
        {
            Header : 'Meter',
            accessor :'meter',
        },
        {
            Header : 'Pieces',
            accessor : 'PCS',
        },
        {
            Header : 'Cut',
            accessor : 'cut'
        },
        {
            Header : 'Send Qty',
            accessor : 'sendQuantity'
        }
    ];

    const jobDetailsData = useMemo(() => (data?.length ? data : []), [data]);

    return (
        <ModalBasic
            modalOpen={detailsModalOpen}
            setModalOpen={setDetailsModalOpen}
        >
            <div className="p-4">
                <TableWithHeadingAndSearch
                    data={jobDetailsData}
                    columns={cols}
                    heading={'Job Work Details'}
                />
            </div>
        </ModalBasic>
    );
};

export default JobWorkDetailsModal;
